import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { optimizeName } from '../../other/vod-series-name-optimizer';
import DB from '../../other/local-db';
import { generateUrl } from '../../other/generate-url';

const RowItem = ({
  name,
  stream_icon,
  last,
  stream_id,
  category_id,
  id,
  style,
  isSeries,
  container_extension,
  existingTmdb,
}) => {
  const [noCover, setNoCover] = useState(!stream_icon);
  const [streamStat, setStreamStat] = useState();

  const styleLast = {
    position: 'absolute',
    height: 'calc(15vw * 1.5)',
    right: 'calc(-7% - 0.4rem)',
    width: '100%',
    filter: 'brightness(0.5)',
    pointerEvents: 'none',
    cursor: 'default',
    textDecoration: 'none',
  };

  const noCoverStyle = {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#0c0f13',
    border: '0.2rem solid white',
    justifyContent: 'center',
  };
  
  useEffect(() => {
    setStreamStat(DB.findOne(isSeries ? 'series' : 'movie', stream_id, category_id === 'fav'));
  }, [isSeries, stream_id, category_id]);

  return (
<Box
  component={Link}
  className={`col-2 ${!last && 'vod'}`}
  data-id={id}
  sx={{
    maxHeight: '60vh',
    textAlign: 'center',
    flex: '0 0 15.266667%',
    maxWidth: '15.266667%',
    padding: '0.4rem',
    cursor: 'pointer',
    outline: 'none', // Remove default outline
    textDecoration: 'none !important', // Remove underline from Link
    boxSizing: 'border-box',
    position: 'relative', // Required for box-shadow to work correctly
    height: 'calc(15vw * 1.5 + 3rem)', // Include space for the title box
    transition: 'box-shadow 0.3s ease',
    '&:hover, &:focus': {
      boxShadow: 'rgb(0, 255, 255 / 75%) 0px 3px 15px', // Electric blue highlight
      outline: '2px solid #00ffff', // Optional electric blue outline
    },
    ...(style || {}),
    ...(last ? styleLast : {}),
  }}
  to={{
    pathname: `/${isSeries ? 'series' : 'movie'}/category/${category_id}/${stream_id}/info/`,
    search: window.location.search,
  }}
>
  {/* Wrapper for both the image and title */}
  <Box
    sx={{
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column', // Stack the image and title vertically
    }}
  >
    {/* Cover */}
    <Box
      sx={{
        height: 'calc(100% - 3rem)', // Reserve space for the title box
        width: '100%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        borderTopLeftRadius: '.5rem',
        borderTopRightRadius: '.5rem',
        ...(noCover ? noCoverStyle : { backgroundImage: `url(${stream_icon})` }),
      }}
    >
      {!noCover ? (
        <img
          src={stream_icon}
          width={0}
          height={0}
          onError={() => setNoCover(true)}
          alt={name}
        />
      ) : (
        <Typography
          variant="h6"
          sx={{
            fontSize: '1.2rem',
            pt: '1rem',
            lineHeight: '1.6rem',
            overflow: 'hidden',
            color: 'white',
          }}
        >
          {optimizeName(name)}
        </Typography>
      )}
    </Box>

    {/* Title Box */}
    <Box
      sx={{
        backgroundColor: '#2a2a2a',
        width: '100%',
        borderBottomLeftRadius: '.5rem',
        borderBottomRightRadius: '.5rem',
        paddingY: '0.5rem',
        textAlign: 'center',
      }}
    >
      <Typography
        sx={{
          color: 'white',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          fontSize: '1rem',
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        {optimizeName(name)}
      </Typography>
    </Box>
  </Box>
</Box>
  );
};

export default RowItem;
